export type FieldKind = 'phone' | 'email' | 'url';

function looksLikeEmail(s: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
}

function isUrl(s: string): boolean {
  try { new URL(s); return true; } catch { /* fall through */ }
  try { new URL(`https://${s}`); return true; } catch { return false; }
}

export function validateField(value: string, kind: FieldKind): string | null {
  const trimmed = value.trim();
  if (trimmed.length === 0) return null;

  switch (kind) {
    case 'phone': {
      const digits = trimmed.replace(/\D/g, '');
      return digits.length >= 7 ? null : 'Enter at least 7 digits';
    }
    case 'email':
      return looksLikeEmail(trimmed) ? null : 'Invalid email format';
    case 'url':
      return isUrl(trimmed) ? null : 'Invalid URL';
  }
}
